import SwiftCacheList from './swiftcache.vue';
import SwiftCacheForm from './swiftcache-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/swiftcache/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('swiftcache', ['ADMIN'], SwiftCacheList),
        keepAlive: true
    },
    {
        path: '/swiftcache/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('swiftcache/new', ['ADMIN'], SwiftCacheForm)
    },
    {
        path: '/swiftcache/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('swiftcache/edit', ['ADMIN'], SwiftCacheForm)
    },
    {
        path: '/swiftcache/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('swiftcache/view', ['ADMIN'], SwiftCacheForm, { editable: false })
    },
];
export default routes;
